module.exports = __webpack_public_path__ + "img/product-showcase-gallery-05.d6678e0c.jpg";